import Segment from '../scripts/Segment';

const SegmentScript = () => {
  return <Segment />;
};
export default SegmentScript;
